import { Injectable } from '@angular/core';
import { DownloadTaskProgress } from '@core/interfaces/download-task-progress';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadTaskProgressService {
  #taskProgress: DownloadTaskProgress[] = [];
  #progress: BehaviorSubject<DownloadTaskProgress[]> = new BehaviorSubject<DownloadTaskProgress[]>(null);

  public downloadTaskProgress(): Observable<DownloadTaskProgress[]> {
    return this.#progress.asObservable();
  }

  public setProgressValueForTasks(taskIds: string[], progressPercentage: number): void {
    taskIds.forEach(taskId => {
      this.setProgressValue(taskId, progressPercentage);
    });
  }

  public setProgressValue(taskId: string, progressPercentage: number): void {
    const itemIndex = this.#taskProgress.findIndex(t => t.taskId === taskId);
    if (itemIndex >= 0) {
      if (progressPercentage < 100) {
        this.#taskProgress[itemIndex].progressPercentage = progressPercentage;
      } else {
        this.#taskProgress.splice(itemIndex, 1);
      }
    } else {
      this.#taskProgress.push({ taskId, progressPercentage });
    }
    this.#progress.next(this.#taskProgress);
  }

  public downloadFailedForTasks(taskIds: string[]): void {
    taskIds.forEach(taskId => {
      const itemIndex = this.#taskProgress.findIndex(t => t.taskId === taskId);
      this.#taskProgress.splice(itemIndex, 1);
    });
  }

  public clearProgress(): void {
    this.#taskProgress = null;
    this.#progress.next(this.#taskProgress);
  }
}
